import {Area} from "./Area";
import {AreaRepository} from "./AreaBaseRepository";

export class AreaRemoteRepository implements AreaRepository {

    private static URL = 'https://uji-apps-wifi.s3-eu-west-1.amazonaws.com/edificios.json';

    public async fetchAreas(): Promise<Area[]> {
        const data = await fetch(AreaRemoteRepository.URL)
            .then((res) => res.json())

        return data
            .map((item: any) => ({
                name: item.name,
                cords: item.cords,
            }))
            .sort((a: Area, b: Area) => a.name.localeCompare(b.name));
    }
}
